export default __webpack_public_path__ + "static/media/high-res-marketing.7de7727a.png";